import { render } from "./IosInstallBanner.vue?vue&type=template&id=8e397ec0&scoped=true"
import script from "./IosInstallBanner.vue?vue&type=script&lang=js"
export * from "./IosInstallBanner.vue?vue&type=script&lang=js"

import "./IosInstallBanner.vue?vue&type=style&index=0&id=8e397ec0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e397ec0"]])

export default __exports__